export const sensitivityMenuText = "_5a";
export default {sensitivityMenuText};